import Vue from 'vue';
import Vuetify from 'vuetify';
import VueResource from 'vue-resource';

import App from './App';
import router from './router';
import store from './store';

import 'vuetify/dist/vuetify.min.css';
import './assets/styles.css';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

import AuthService from '@/services/AuthService';
import VueClipboards from 'vue-clipboards';
import Vue2Filters from 'vue2-filters';
import VeeValidate from 'vee-validate';
import GoogleAuth from 'vue-google-auth';

Vue.config.productionTip = false;

Vue.use(Vuetify);
Vue.use(VueResource);
Vue.use(VueClipboards);
Vue.use(Vue2Filters);
Vue.use(VeeValidate);
Vue.use(GoogleAuth, {
    client_id: `${process.env.GOOGLE_CLIENT_ID}`
});
Vue.googleAuth().load();

Vue.http.interceptors.push((request, next) => {
    request.headers.set('Authorization', AuthService.getAuthToken());
    next((response) => {
        if (response.status === 401) {
            let authService = new AuthService(store);
            return authService.refresh().then(() => {
                request.headers.set('Authorization', AuthService.getAuthToken());
                return Vue.http(request).then(data => {
                    return data;
                });
            }, () => {
                authService.logOut();
                return router.push('/login');
            });
        }
    });
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {
        App
    }
});



// WEBPACK FOOTER //
// ./src/main.js